
<div class="conf-table">
    <table mat-table [dataSource]="jurisdictions" class="mat-elevation-z8">

        <ng-container matColumnDef="srNo">
            <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
        </ng-container>

        <ng-container matColumnDef="jurisdictionName">
            <th mat-header-cell *matHeaderCellDef> Jurisdiction </th>
            <td mat-cell *matCellDef="let element"> {{ element.jurisdictionName }} </td>
        </ng-container>

        <ng-container matColumnDef="uboPercentage">
            <th mat-header-cell *matHeaderCellDef> UBO % </th>
            <td mat-cell *matCellDef="let element"> {{ element.uboPercentage }} </td>
        </ng-container>

        <ng-container matColumnDef="fallbackMatterId">
            <th mat-header-cell *matHeaderCellDef> Fallback Matter ID </th>
            <td mat-cell *matCellDef="let element"> {{ element.fallbackMatterId }} </td>
        </ng-container>

        <ng-container matColumnDef="individualCharge">
            <th mat-header-cell *matHeaderCellDef> Individual Charge </th>
            <td mat-cell *matCellDef="let element"> {{ element.individualCharge }} </td>
        </ng-container>

        <ng-container matColumnDef="companyCharge">
            <th mat-header-cell *matHeaderCellDef> Company Charge </th>
            <td mat-cell *matCellDef="let element"> {{ element.companyCharge }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button color="primary" (click)="openEditDialog(element)">
                    <mat-icon style="color:var(--accent-color);">edit</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>


